module.exports = __webpack_public_path__ + "img/7D7673_353230_AEA7B0_4C4444-256px.a58d9619.png";